import React, { useState } from 'react';

export default function AdminEmailSection({ appId }) {
  const [expandedSections, setExpandedSections] = useState({
    resend: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>📧</span>
          <span>Email</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Email service configuration and delivery
        </p>
      </div>

      <div className="space-y-4">
        {/* Resend Configuration */}
        <div className="border border-gray-200 rounded-lg">
          <button
            onClick={() => toggleSection('resend')}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
          >
            <h4 className="text-sm font-semibold text-gray-900">Resend</h4>
            <span className="text-gray-500 text-sm">
              {expandedSections.resend ? '▼' : '▶'}
            </span>
          </button>
          {expandedSections.resend && (
            <div className="p-4 pt-4 border-t border-gray-200 bg-gray-50">
              <div className="space-y-2 text-sm text-gray-700">
                <p className="text-xs text-gray-600 mb-3">
                  Resend is an email API for developers. Send transactional and marketing emails at scale with a simple, elegant interface and SDKs for your favorite programming languages.
                </p>
                <div className="mt-3">
                  <a
                    href="https://resend.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
                  >
                    Open Resend →
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

